const tabs = {
  dashboard: "Дашборд",
  appLauncher: "Все приложения",
  apps: "Все приложения",
  layers: "Хаб",
  vcards: "vCards",
  // Legacy names — kept so old keys still resolve; the app itself is vCards now.
  editor: "Редактор",
  vtaskPool: "Пул задач",
  storyMap: "vStory",
  notebook: "Блокнот",
  memory: "Память",
  chat: "Внутренний чат",
  news: "Новости",
  osMap: "Карта ОС",
  virtualOffice: "Виртуальный офис",
  roadmapBlack: "Roadmap — Хребет",
  specs: "Спецификация системы",
  functionalMap: "Функциональная карта",
  budget: "vBudget · Поток",
  aiHub: "AI Hub",
  aiHome: "AI Дом",
  cliAi: "CLI AI",
  aiAdvisors: "AI Советники",
  advisors: "AI Советники",
  agents: "Agents (Скоро)",
  aiKnowledge: "AI Knowledge (Скоро)",
  semanticBrain: "Здоровье мозга",
  libraries: "Библиотеки",
  fieldTemplates: "Шаблоны полей (Скоро)",
  iconLibrary: "Библиотека иконок",
  databases: "Представления | DB",
  integrations: "Интеграции",
  myConnections: "Мои подключения",
  appStore: "Магазин приложений",
  sync: "Синхронизация Origami",
  vault: "vPassword",
  vaultPasswords: "Пароли",
  vaultSecrets: "Зашифрованные данные",
  vaultAudit: "Аудит дрейфа",
  vaultTeam: "Командное хранилище",
  vcloud: "vCloud",
  vcloudFiles: "Файлы",
  vcloudImages: "Галерея",
  vcloudVideo: "Видео",
  vcloudSound: "Звук",
  vcloudPersonal: "Личные данные",
  designSystem: "Дизайн-система",
  architecture: "Архитектура",
  plan: "План",
  roadmap: "Управление работой",
  vTool: "vTool",
  settings: "Настройки",
  automations: "Автоматизация",
  vdev: "PM — Управление разработкой",
  taskInbox: "Входящие задачи",
  control: "Центр управления",
  admin: "Журнал разработки",
  adminDataBrain: "Данные и мозг",
  health: "Здоровье системы",
  systemCleanup: "Очистка системы",
  serverHealth: "Состояние сервера",
  integrationHealth: "Здоровье интеграций",
  honeypot: "Ловушки-приманки",
  maintenance: "Обслуживание кода",
  dbExplorer: "Обозреватель БД",
  dbRegistry: "Индекс таблиц",
  referenceApp: "Справочник",
  notionOrder: "Организация Notion",
  alerts: "🤖 Центр уведомлений",
  identityResolver: "Resolver организаций",
  agentAccess: "🔑 Доступ агентов",
  entities: "Сущности",
  viewsApp: "Представления",
  pinkas100: "Подрядчики 100",
  pinkasKablanim: "Реестр подрядчиков",
  investigator: "Бизнес-разведка",
  memoryCatalog: "Библиотека памяти",
  bookmarksApp: "Закладки",
  ideaBacklog: "Идеи и планы",
  windmill: "Windmill",
  embeddedTools: "Встроенные инструменты",
  entityFields: "Библиотека полей",
  entityTypes: "Типы сущностей",
  knowledge: "База знаний",
  knowledgeSources: "Полка источников",
  researchLibrary: "Библиотека исследований",
  playbooks: "Плейбуки",
  skills: "Claude Stack",
  skillsStore: "Магазин шаблонов (Скоро)",
  grid: "Таблица",
  slides: "Слайды",
  boardroom: "Совет",
  feeds: "RSS-ленты",
  bookmarks: "Bookmarks",
  readList: "Read List (Скоро)",
  import: "Импорт",
  matching: "Совпадения",
  matchingEngine: "Движок подбора",
  talentSearch: "Поиск специалистов",
  comms: "Коммуникация",
  whatsapp: "WhatsApp",
  documents: "Документы",
  vclip: "vClip",
  vcanvas: "vCanvas",
  weeklyPlanner: "Недельный планировщик",
  audit: "Журнал аудита",
  templates: "Шаблоны",
  emailTemplates: "Шаблоны email",
  phoneTemplates: "Шаблоны сообщений (Скоро)",
  prompts: "Промпты (Скоро)",
  toolkit: "Инструменты",
  courses: "Библиотека курсов",
  cost: "Контроль расходов",
} as const;
export default tabs;
